import { render, staticRenderFns } from "./HomeEntry.vue?vue&type=template&id=28c8a5d8&"
import script from "./HomeEntry.vue?vue&type=script&lang=js&"
export * from "./HomeEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports